const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        $('.team-member-image').on('click', _this.openTeamPopupImage);
        $('.team-member-name').on('click', _this.openTeamPopupName);
        $('.team-member-box-popup-close').on('click', _this.closeTeamPopup);
        $('.team-member-box-popup').on('click', _this.clickOutsidePopup);
    },

    openTeamPopupImage: function() {
        $(this).parent().find('.team-member-box-popup').addClass('active');
    },

    openTeamPopupName: function() {
        $(this).parent().parent().find('.team-member-box-popup').addClass('active');
    },

    closeTeamPopup: function() {
        $('.team-member-box-popup').removeClass('active');
    },

    clickOutsidePopup: function(e) {
        console.log(e.target);
        if(!$('.team-member-box-popup-inner').is(e.target) && !$('.team-member-box-popup-name').is(e.target) && !$('.team-member-box-popup-role').is(e.target) && !$('.team-member-box-popup-bio').is(e.target)) {
            console.log('ssksk');
            $(this).removeClass('active');
        }
    },

}

export default _this;